import tw from 'twin.macro';

export const Wrapper = tw.div`2xl:text-2xl flex font-semibold items-center text-lg text-gray-600`;

export const PaginationIcon = tw.i`text-2xl hover:text-gray-800
 hover:text-4xl duration-300 transition-all
 cursor-pointer mx-2`;

export const Input = tw.input`border border-gray-300
 font-semibold rounded-md mr-1 outline-none text-center w-10`;
